import { z } from 'zod';
/**
 * The choices of a contract's terms that need nothing else of the domain: how receipts come, the
 * direct debit, the yes-or-no terms, the protection of e-mails and the post. Apart from the terms
 * themselves, so that the firm's catalogue can name its standard for them (`draft-questions.ts`).
 */
export const ReceiptChannel = z.enum(['digital', 'paper']).meta({ id: 'ReceiptChannel' });
export const SepaScheme = z.enum(['core', 'b2b']).meta({ id: 'SepaScheme' });
/**
 * Yes-or-no terms of a contract that the library's conditions read (STBV-C "Eingaben", source
 * "Vertrag"). Not chosen is not agreed: a pickup service nobody agreed is no part of the contract.
 */
export const ENGAGEMENT_OPTIONS = [
    'usesDatevOnline',
    'permanentExtension',
    'keepsCash',
    'onlineCashBook',
    'bankOnline',
    'assignsReceiptsOnline',
    'pickupService',
    'payrollReportsOnPaper',
    'payrollReportsShipped',
    'signOffOnPaper',
    'firmScansReceipts',
    'firmScansAnnualReceipts',
    'taxNoticeReceiptAuthorised',
    'consumerRequestsEarlyStart',
    'clientAccountsOnBalanceSheet',
    'thirdPartyData',
    'sensitiveDataUnencrypted',
    'excludesMessenger',
    'excludesEmail',
    'excludesFax',
    'generalPowerOfAttorney',
    'taxPowerOfAttorney',
    'moneyReceiptAuthorised',
    'taxPoaRestricted',
    'taxPoaLimitedInTime',
    'taxDataRetrieval',
    'taxSubPower',
    'disclosureToThirdParties',
    'thirdPartyExperts',
    'usesBillingAgency',
];
/**
 * Protection of e-mails (E7.KOMM.030): the firm's encryption, password-protected attachments, or
 * expressly transport encryption only. A password is never part of a document (K-B2-11).
 */
export const EmailProtection = z
    .enum(['firm_encryption', 'password', 'transport_only'])
    .meta({ id: 'EmailProtection' });
/** Post to the client (E7.KOMM.070): without restriction, marked personal only, or none. */
export const PostMode = z.enum(['unrestricted', 'personal_only', 'none']).meta({ id: 'PostMode' });
//# sourceMappingURL=engagement-choices.js.map